/** People Landing — campos del bloque "richtext". Hasta el 21/09/2026 vivía en BlockEditorDialog.tsx. */
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { type LandingAlign } from '../../../../../../shared/types/people-landing';
import { AlignControl } from '../controls';
import type { EditorFieldProps } from '../types';

export function RichtextFields({ draft, set }: EditorFieldProps) {
  const { t } = useTranslation();
  return (
    <>
      <div className="grid grid-cols-[1fr_auto] gap-3 items-end">
        <div className="space-y-1.5">
          <Label>{t('people_landing.editor.section_title', 'Título de sección (opcional)')}</Label>
          <Input value={draft.title ?? ''} onChange={(e) => set({ title: e.target.value })} />
        </div>
        <div className="space-y-1.5">
          <Label>{t('people_landing.editor.align', 'Alineación')}</Label>
          <div>
            <AlignControl value={(draft.align ?? 'left') as LandingAlign} onChange={(a) => set({ align: a })} />
          </div>
        </div>
      </div>
      <div className="space-y-1.5">
        <Label>{t('people_landing.editor.markdown', 'Contenido (markdown)')}</Label>
        <Textarea
          value={draft.markdown ?? ''}
          onChange={(e) => set({ markdown: e.target.value })}
          rows={14}
          className="font-mono text-[13px]"
        />
        <p className="text-xs text-muted-foreground">
          {t(
            'people_landing.editor.markdown_hint',
            'Formato: # título, **negrita**, *cursiva*, [link](https://…), - lista'
          )}
        </p>
      </div>
    </>
  );
}
